// extracted by mini-css-extract-plugin
module.exports = {"Signup":"Signup_Signup__2IeMw","help-block":"Signup_help-block__kxzva"};